import React, { useEffect } from 'react';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
// import ScrollableAnchor from 'react-scrollable-anchor';
import withCustomComponent from 'ui/components/withCustomComponent';
import PlansTable from 'ui/_pages/plan/PlansTable';
import {ScrollableAnchor} from "../../../bruntwood/ScrollableAnchor";

export const HomePlansSection = withCustomComponent('HomePlansSection')(
  inject(
    'authStore',
    'appStore',
    'invoicingStore'
  )(
    withRouter(
      observer(
        ({ router, authStore, invoicingStore, appStore, componentName }) => {
          const { t } = useTranslation();
          const { homePage } = appStore;
          const isVirtualDashboard = appStore.virtualDashboard;

          const onPlanSelected = (plan) => {
            router.push(
              routes.signup_plan_link('[tariff_guid]'),
              routes.signup_plan_link(plan.tariff)
            );
          };

          return (
            <>
              {appStore.homePage?.PricePlans?.length > 0 && (
                <ScrollableAnchor id={'priceplans'}>
                  <div
                    data-component-name={componentName}
                    className="home-plans-section"
                  >
                    <div className="container">
                      <h2 className="h1 mb-32 text-center">
                        {isVirtualDashboard
                          ? t('Plans and Benefits')
                          : t('Our plans')}
                      </h2>
                      <PlansTable
                        onPlanSelected={(plan) => onPlanSelected(plan)}
                        hideTitle={true}
                        showStartDate={false}
                      />
                    </div>
                  </div>
                </ScrollableAnchor>
              )}
            </>
          );
        }
      )
    )
  )
);
